import { gql } from '@apollo/client';
const SET_ORDER_DELIVERY_DATE = gql `
  mutation SetOrderDeliveryDate($orderId: ID!, $orderDeliveryDate: DateTime!) {
    setOrderDeliveryDate(orderId: $orderId, orderDeliveryDate: $orderDeliveryDate) {
      order {
        id
        orderDeliveryDate
      }
    }
  }
`;
export default SET_ORDER_DELIVERY_DATE;
